import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { BrowserStorageService } from "app/main/shared/services/browser-storage.service";

@Component({
  selector: "view-preference",
  templateUrl: "./view-preference.component.html",
  styleUrls: ["./view-preference.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewPreferenceComponent implements OnInit {
  constructor(private _browserStorage: BrowserStorageService) {}

  @Input() viewPreference: string;
  @Input() showViews: string[] = ["listView", "tableView", "cardView"];
  @Input() componentName: string = "";
  @Output() viewChanged = new EventEmitter();

  allViews = [
    {
      label: "List View",
      value: "listView",
      icon: "reorder"
    },
    {
      label: "Table View",
      value: "tableView",
      icon: "table_chart"
    },
    {
      label: "Card View",
      value: "cardView",
      icon: "view_module"
    }
  ];

  ngOnInit() {
    this.checkSavedView();
  }

  checkSavedView() {
    const { componentName, showViews } = this;
    if (!componentName) return;
    const selectedView = this._browserStorage.getItemFromLS(componentName);
    if (!!selectedView && showViews.includes(selectedView)) {
      this.viewPreference = selectedView;
      this.viewChanged.emit(selectedView);
    }
  }

  handleViewChanged({ value }) {
    this._browserStorage.setItemInLS(this.componentName, value);
    this.viewPreference = value;
    this.viewChanged.emit(value);
  }
}
